import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderProgramOwnerDataSchema } from './ServicesProviderProgramOwnerData.js';

class ServicesProviderProgramOwner extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
        this.analyticsBoardUrl = data.analyticsBoardUrl;
    }
    validateData(data) {
        const result = servicesProviderProgramOwnerDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderProgramOwner.validation', `ServicesProviderProgramOwner data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.PROGRAM_OWNER,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.PROGRAM_OWNER, ServicesProviderProgramOwner);

export { ServicesProviderProgramOwner };
//# sourceMappingURL=ServicesProviderProgramOwner.js.map
